import React, { useEffect, useState } from "react";
import { connect, useFormikContext } from "formik";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import random from "lodash/random";
import { COLORS } from "utils/styles";
import classnames from "classnames";
import { getIconForUID } from "components/FormerEditor/utils";
import {
  getStandardVariants,
  loadFontFamily,
  fontFamilyIsLoaded
} from "utils/theme";
import { usePageBuilderContext } from "utils/context";
import Analytics, { SELECT_FONT_FAMILY } from "utils/analytics";

const FontFamilySelector = (props) => {
  const builderCtx = usePageBuilderContext();
  const tracking = builderCtx && builderCtx.tracking ? builderCtx.tracking : {};

  const width = random(5, 10) * 10;
  const [error, setError] = useState(null);
  const [hover, setHover] = useState(null);
  const [fetched, setFetched] = useState(false);

  const { family, variants, isVisible } = props;
  const fontLoaded = fontFamilyIsLoaded(family);
  const shouldLoadFont = !fontLoaded && isVisible && !fetched;
  useEffect(() => {
    if (shouldLoadFont) {
      try {
        loadFontFamily({ family, variants });
      } catch (error) {
        setError(error);
      }

      setFetched(true);
    }
  }, [shouldLoadFont]);

  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const currentFont = get(values, STATE_KEYS.THEME.FONT_FAMILY);
  const isTouched = get(touched, STATE_KEYS.THEME.FONT);
  const isActive = family === currentFont && currentFont.toLowerCase();
  const Icon = getIconForUID("checkmark");

  const containerProps = {
    className:
      "font-family--preview bb hairline-1 pa3 pointer bh--inset bg-white--hover",
    onClick: () => {
      const chosenFamily = {
        family,
        variants: getStandardVariants(variants)
      };
      Analytics.track(SELECT_FONT_FAMILY, {
        ...tracking,
        font_family: family
      });

      setFieldValue(STATE_KEYS.THEME.FONT, chosenFamily);
      if (!isTouched) {
        setFieldTouched(STATE_KEYS.THEME.FONT, true);
      }
    },
    onMouseEnter: () => !hover && setHover(true),
    onMouseLeave: () => hover && setHover(false)
  };
  let icon;
  if (isActive || hover) {
    const color = isActive ? COLORS.blue : COLORS.deselected;
    icon = <Icon size={18} color={color} />;
  }
  return (
    <div {...containerProps}>
      {!fontLoaded && !fetched ? (
        <div className={`shimmer h2 w-${width}`} />
      ) : (
        <div className="flex flex-row justify-between items-center">
          <div className="f5">{family}</div>
          {icon}
        </div>
      )}
      <style jsx>{`
        .font-family--preview {
          font-family: ${family};
        }
        font-family--preview:hover {
          background-color: ${COLORS.content.secondary};
        }
      `}</style>
    </div>
  );
};

export default FontFamilySelector;
